export default __webpack_public_path__ + "static/media/alex_m.b3de0dbe.jpg";